import auth from './auth';
const indexedVariable = {
  auth,
};
export default indexedVariable;
